'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_jsonCodecs$package$$anon$171(ps$91) {
  this.a6Y = null;
  this.a6Y = ps$91;
}
export { $c_Lmealorama_jsonCodecs$package$$anon$171 as $c_Lmealorama_jsonCodecs$package$$anon$171 };
$p = $c_Lmealorama_jsonCodecs$package$$anon$171.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_jsonCodecs$package$$anon$171;
/** @constructor */
function $h_Lmealorama_jsonCodecs$package$$anon$171() {
}
export { $h_Lmealorama_jsonCodecs$package$$anon$171 as $h_Lmealorama_jsonCodecs$package$$anon$171 };
$h_Lmealorama_jsonCodecs$package$$anon$171.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return "";
});
$p.q = (function() {
  return this.a6Y.a.length;
});
$p.g = (function(i) {
  return this.a6Y.a[i];
});
var $d_Lmealorama_jsonCodecs$package$$anon$171 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_jsonCodecs$package$$anon$171, "mealorama.jsonCodecs$package$$anon$171", ({
  Jo: 1,
  b: 1,
  c: 1
}));
export { $d_Lmealorama_jsonCodecs$package$$anon$171 as $d_Lmealorama_jsonCodecs$package$$anon$171 };
//# sourceMappingURL=mealorama.json-Codecs$package$$anon$171.js.map
